import { Roles, UserService } from '@/app/shared/services/user.service'
import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

/**
 * Réserve une route au rôle GlobalAdmin. Le MsalGuard parent garantit déjà l'authentification ;
 * ici on vérifie le rôle (claim coreRoles) et on redirige sinon.
 */
export const adminGuard: CanActivateFn = () => {
  const user = inject(UserService)
  const router = inject(Router)

  if (user.hasRole(Roles.GlobalAdmin)) return true

  return router.createUrlTree(['/requisitions'])
}
